import { Pipe, PipeTransform } from '@angular/core';
import { Observable, map } from 'rxjs';
import { MetaService } from '../_services/meta.service';
import { formatLabel, formatLabelUpper } from './label-utils';

@Pipe({ name: 'enumLabel' })
export class EnumLabelPipe implements PipeTransform {
  constructor(private metaService: MetaService) {}

  transform(value: number, enumName: string, upper = false): Observable<string> {
    return this.metaService.getEnums().pipe(
      map(enums => {
        const item = enums?.[enumName]?.find(e => e.value === value);
        const label = item?.label ?? `Unknown (${value})`;
        return upper ? formatLabelUpper(label) : formatLabel(label);
      })
    );
  }
}
